import { defineMessages } from 'react-intl';

export default defineMessages({
  importSuccess: 'Content imported',
  importFail: 'Failed to import content. Please try again later.',
  survey: 'Survey',
  surveyRequired: 'Please select a survey from which to import content',
  surveyPlaceholder: 'Select a survey to import content',
});
